<script lang="ts" setup>
import {
  ref,
  shallowRef,
  computed,
  defineAsyncComponent,
  watch,
  DefineComponent
} from 'vue'
import { useWidgetStore } from '@/stores/widget'

export interface DialogData {
  title: string
  description: string
  isOpen: boolean
  positiveActionText: string
  negativeActionText: string
}

const widgetStore = useWidgetStore()

const isOpen = ref(false)
const component = shallowRef<DefineComponent | null>(null)

const activeDialog = computed(() => widgetStore.activeDialog)

watch(activeDialog, (dialogData) => {
  if (dialogData) {
    component.value = defineAsyncComponent(dialogData.loader)
    isOpen.value = true
  } else {
    isOpen.value = false
    component.value = null
  }
})

const onPositiveAction = (contextData: any) => {
  activeDialog.value?.positiveAction?.(contextData)
}

const closeDialog = () => {
  isOpen.value = false
  widgetStore.closeDialog()
}
</script>

<template>
  <div>
    <Suspense>
      <Component
        :is="component"
        v-if="component"
        v-bind="activeDialog?.props"
        :is-open="isOpen"
        v-on="activeDialog?.events || {}"
        @positive-action="onPositiveAction"
        @close="closeDialog"
      />
    </Suspense>
  </div>
</template>
